import React, { useId } from "react";
import { useTranslation } from "react-i18next";
import { Box, InputLabel } from "@mui/material";
import { RangeSelectorControlProps } from "@hooks";
import { CollapsibleRangeSelector } from "@components/Chart/ChartControls";

export const PERIOD_PRESETS: IntervalType[] = [
  "oneMonth",
  "sixMonths",
  "YTD",
  "oneYear",
  "threeYears",
  "sinceBeginning",
  "custom",
];

interface Props {
  rangeProps: RangeSelectorControlProps;
  intervalTypes?: IntervalType[];
}

export const PeriodSetting = ({
  rangeProps,
  intervalTypes = PERIOD_PRESETS,
}: Props) => {
  const { t } = useTranslation();
  const labelId = useId();

  return (
    <Box role="group" aria-labelledby={labelId}>
      <InputLabel id={labelId}>{t("bookingsTable.period")}</InputLabel>
      <CollapsibleRangeSelector
        rangeProps={rangeProps}
        intervalTypes={intervalTypes}
        fullWidth
      />
    </Box>
  );
};
